import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit {
  @Input() edit: any;
  @Input() type: string;
  defaultImg: string = environment.defaultImg;
  nameCategorie: string = '';
  imagesUploaded: any = [];
  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private modalController: ModalController,
    private translateSv: TranslateService
  ) { }

  ngOnInit() {
    if(this.edit){
      this.nameCategorie = this.edit.name;
      
      if(this.edit.file){

        const img = { url: this.edit.file, file: this.edit.file}
        this.imagesUploaded.push(img);
      }
    }
  }

  setImage(file){
    this.imagesUploaded = file;
  }

  async submit(){
    try{
      await this.uiSv.showLoading();
      let txtType = 'creada';
      const formData = new FormData();
      const file = this.imagesUploaded[0]?.file;
      formData.set('name', this.nameCategorie);
      formData.set('file', file);
      if(this.edit){
        txtType = 'editada'
        formData.set('id', this.edit.id);
        await this.httpSv.itemAction(formData, 'category','update');
      }else{
        if(!file){
          const translate = this.translateSv.instant('SUBE_UNA_IMAGEN');
          this.uiSv.showToast(translate);
          return false;
        }
        await this.httpSv.itemAction(formData, 'category','store');
      }
      await this.uiSv.loading.dismiss();
      await this.modalController.dismiss();
      const translateCat = this.translateSv.instant('CATEGORIA')
      const translateExt = this.translateSv.instant('CON_EXITO');
      await this.uiSv.showToast(`${translateCat} ${txtType} ${translateExt}`);
    }catch(err){
      await this.uiSv.loading.dismiss();
      const translate = this.translateSv.instant('HA_OCURRIDO_UN_ERROR');
      await this.uiSv.showToast(translate);
    }
    
  }

}
